import React, {useContext} from 'react';
import {CorporationContext} from "../context/corporation-context.jsx";
import CorporationImage from "./corporation-image.jsx";
import {Card} from "../../../../components/card/card.jsx";
import Alert from "../../../../components/alert/alert.jsx";
import {useRequiredTabErrors} from "../../../../hooks/use-required-tab-errors.js";

const Tabs = ({tabSelected, setTabSelected}) => {
    const {changes, tabs} = useContext(CorporationContext)
    const {hasRequiredTabError} = useRequiredTabErrors({
        tabKeys: tabs.map(({key}) => key),
        tabSelected,
        setTabSelected,
    });

    return (
        <>
            <CorporationImage />

            <Card className={"flex-1 min-h-0 flex flex-col"}>
                <Card.Body className={"flex-1 min-h-0 flex flex-col gap-2"}>
                    <div className="flex-1 min-h-0 overflow-auto">
                        <div>
                            {tabs.map(({ key, label }, index) => {
                                const keyFind = changes.find((c) => c === key);
                                return (
                                    <p
                                        key={index}
                                        className={`box-border cursor-pointer mb-1 px-1.5 py-0.5 text-[13px] rounded hover:bg-[#d3d3d3] ${
                                            tabSelected === key ? "bg-[#d3d3d3]" : ""
                                        } ${hasRequiredTabError(key) ? "border border-[#dc2626]" : ""}`}
                                        onClick={() => setTabSelected(key)}
                                    >
                                        {label} <span className="ml-1">{keyFind ? "*" : ""}</span>
                                    </p>
                                );
                            })}
                        </div>
                    </div>

                    {changes.length > 0 && (
                        <Alert target={"warning"}>
                            <span className={"text-[13px]"}>* Salve suas alterações antes de sair</span>
                        </Alert>
                    )}
                </Card.Body>
            </Card>
        </>
    );
};

export default Tabs;